import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Axios from 'axios';
import fileDownload from 'js-file-download';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BASE_URL } from 'src/config/api.config';
import { MST } from 'src/config/mobifoneInvoice.config';

//Note:
// trang_thai_thanh_toan: true => da thanh toan
// trang_thai_thanh_toan: false => chua thanh toan
function TableInvoiceRow({ hoaDonInfo }) {
  const {
    mau_hoa_don,
    ky_hieu,
    so_hoa_don,
    trang_thai_hoa_don,
    trang_thai_thanh_toan,
    ngay_hoa_don,
    tong_tien,
    ma_bao_mat,
  } = hoaDonInfo;
  const navigate = useNavigate();
  console.log(trang_thai_thanh_toan);

  const handleGiayBao = async (selectedOption) => {
    toast('Đang tải xin vui lòng đợi');
    let checkHD = await Axios.get(
      `${BASE_URL}/web-api/public/GiayBao/${ma_bao_mat}`,
    );

    if (checkHD.data.message !== 'OK') {
      toast.error(checkHD.data.message);
      return;
    }

    let response = await Axios.get(
      `${BASE_URL}/web-api/public/download/giaybao/${ma_bao_mat}`,
      { responseType: 'blob' },
    );

    const file = new Blob([response.data], {
      type: 'application/pdf',
    });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };
  const handleDownloadPDF = async (selectedOption) => {
    toast('Đang tải xin vui lòng đợi');
    let response = await Axios.post(
      `http://tracuuhoadon.mobifoneinvoice.vn/Tracuu2/PrintInvoice`,
      {
        sobaomat: ma_bao_mat,
        masothue: MST,
        type: 'PDF',
      },
      { responseType: 'blob' },
    );

    const file = new Blob([response.data], {
      type: 'application/pdf',
    });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };
  const handleDownloadZip = async (selectedOption) => {
    toast('Đang tải xin vui lòng đợi');
    let response = await Axios.post(
      `http://tracuuhoadon.mobifoneinvoice.vn/Tracuu2/ExportZipFileXML`,
      { sobaomat: ma_bao_mat, masothue: MST },
      { responseType: 'blob' },
    );
    fileDownload(response.data, `${ma_bao_mat}.zip`);
  };

  return (
    <tr>
      <td>{mau_hoa_don}</td>
      <td>{ky_hieu}</td>
      <td>{trang_thai_hoa_don}</td>
      <td
        style={{
          color: trang_thai_thanh_toan ? 'green' : 'red',
          textAlign: 'left',
        }}>
        {trang_thai_thanh_toan ? 'Đã thanh toán' : 'Chưa thanh toán'}
      </td>
      <td>{so_hoa_don}</td>
      <td>{ngay_hoa_don}</td>
      <td>{tong_tien}</td>
      <td className="text-center">
        <VisibilityIcon onClick={handleGiayBao} style={{ fontSize: 25 }} />
      </td>
      <td className="text-center">
        {trang_thai_thanh_toan && (
          <>
            <VisibilityIcon
              onClick={handleDownloadPDF}
              style={{ fontSize: 25 }}
            />
            <GetAppIcon onClick={handleDownloadZip} style={{ fontSize: 25 }} />
          </>
        )}
      </td>
    </tr>
  );
}

export default TableInvoiceRow;
